<template>
    <div class="analise-visualizador">
        <h2 class="analise-visualizador__titulo">Análise de Documentação</h2>

        <az-pdf-document-viewer :src="documento.url"
                                :height="tamanhoJanela.y + 'px'"
                                :http-header="headerHttp"
                                v-show="documento.url"
                                progress-bar
                                download-button
                                cssClass="analise-visualizador__documento"
                                @download="$emit('downloadDocumento', documento)"/>

        <div>
            <div v-if="exibirRodape()" class="analise-visualizador__rodape">

                <div v-if="opcoesEnvioReenvioAtivas()">
                    <acoes-solicitar-reenvio-documento v-if="botaoSolicitarReenvioAtivo()  && ehPerfilCompradorOuSuperior"
                                             class="analise-visualizador__rodape-botao solicitar-reenvio"
                                             @confirmarSolicitacao="solicitarReenvio(documento, ...arguments)"/>

                    <p v-if="exibirMensagemAguardeReajuste()"
                         class="analise-visualizador__rodape-mensagem">
                          Aguarde o fornecedor realizar o reajuste de proposta
                    </p>
                    <p v-else-if="exibirMensagemAguardeReenvioDocumento()"
                       class="analise-visualizador__rodape-mensagem">
                        Aguarde até o fornecedor reenviar o documento
                    </p>
                </div>

                <div v-if="exibirPipe()" class="analise-visualizador__rodape-mensagem">
                    <span>|</span>
                </div>

                <div v-if="['ANALISADO', 'FINALIZADO', 'ATIVO'].includes(documento.situacao)">
                    <div class="analise-visualizador__rodape-botao-assinatura">
                        <span v-if="documento.virtualizadoJuntado">Documento juntado ao processo digital</span>
                        <span v-else-if="documento.assinado" class="analise-visualizador__rodape-botao-assinado">
                        <i class="icone fas fa-check-circle" aria-hidden="true"/>
                        Documento Assinado
                        </span>
                        <span v-else v-az-auth="'Comprador.Admin,Comprador.Normal,Comprador.Autoridade.Superior'">
                            <botao-solicitar-assinatura
                                v-if="exibirBotaoAssinatura(documento)"
                                :statusAssinatura="calcularStatusAssinatura(documento)"
                                @confirmarSolicitacao="solicitarAssinatura(documento)"
                            />
                            <span v-else-if="exibirMensagemAssinaturaSolicitada(documento)">Assinatura Solicitada</span>
                            <span v-else-if="documento.tipoDocumento === 'REAJUSTE_PROPOSTA' && situacaoCompraDireta === 'ENCERRADA'">
                                A solicitação de assinatura estará disponível após o encerramento da compra.
                            </span>
                        </span>
                    </div>
                </div>
            </div>
            <div v-else-if="situacaoFornecedor === 'DESCLASSIFICADO'" class="analise-visualizador__rodape">
                <span v-if="itemLoteTipo === 'ITEM'" class="analise-visualizador__rodape-mensagem">
                  O fornecedor não está classificado para este item.
                </span>
                <span v-else class="analise-visualizador__rodape-mensagem">
                  O fornecedor não está classificado para este lote.
                </span>
            </div>
        </div>
        <div class="div-mensagem-botao-documento-nao-enviado" v-if="documento.situacao === 'AGUARDANDO_ENVIO'">
            <div>
                <p style="color: #7f7f7f;">
                  O documento ainda não foi enviado pelo fornecedor.
                </p>
                <p style="color: #7f7f7f;" v-az-auth="'Comprador.Admin,Comprador.Normal,Comprador.Autoridade.Superior'">
                  Aguarde até que o fornecedor envie o documento ou clique no botão abaixo para solicitar o envio:
                </p>
                <acoes-solicitar-envio-documento v-az-auth="'Comprador.Admin,Comprador.Normal,Comprador.Autoridade.Superior'"
                    @confirmarSolicitacaoEnvioDocumento="solicitarEnvioDocumento(documento, ...arguments)"/>

            </div>
        </div>
    </div>
</template>

<script>
import {situacoesReajusteProposta} from '@/core/constants'
import BotaoSolicitarAssinatura from './BotaoSolicitarAssinatura'
import AcoesSolicitarReenvioDocumento from './AcoesSolicitarReenvioDocumento'
import AcoesSolicitarEnvioDocumento from './AcoesSolicitarEnvioDocumento'
import {mapState} from 'vuex'
import azAuth from '@azinformatica/loki/src/utils/az-auth'

export default {
    name: 'AnaliseDocumentacaoDocumento',
    components: {AcoesSolicitarEnvioDocumento, BotaoSolicitarAssinatura, AcoesSolicitarReenvioDocumento},
    props: {
        documento: {
            type: Object,
            default: null
        },
        situacaoCompraDireta: null,
        situacaoItemLote:{
            type: String,
            default: null
        },
        situacaoCompraEnum: {
            type: String,
            required: true
        },
        situacaoFornecedor: {
            type: String,
            default: null
        },
        itemLoteTipo:{
            type: String,
            default: null
        },
        virtualizacao: {
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        situacoesReajusteProposta,
        tamanhoJanela: {
            x: 0,
            y: 0
        }
    }),
    computed: {
        ...mapState(['token', 'loki']),
        headerHttp(){
            return {
                Authorization: this.token
            }
        },
        ehPerfilCompradorOuSuperior(){
            return azAuth(this.loki.user.authorities, ['Comprador.Normal', 'Comprador.Admin', 'Comprador.Autoridade.Superior'])
        }
    },
    created() {
        window.addEventListener('resize', this.handleResize)
        this.handleResize()
    },
    methods: {
        opcoesEnvioReenvioAtivas(){
            return !this.documento.solicitadoAssinatura && !this.documento.virtualizadoJuntado
        },
        botaoSolicitarReenvioAtivo(){
            return this.documento.situacao === 'ANALISADO'
                    && ['Em Analise','Reanálise'].includes(this.situacaoCompraDireta)
                    && this.itemLoteSituacao !== 'ADJUDICADO'
        },
        exibirMensagemAguardeReajuste(){
            return this.documento.situacao === this.situacoesReajusteProposta.EM_ELABORACAO
        },
        exibirMensagemAguardeEnvioDocumento(){
            return this.documento.situacao === 'AGUARDANDO_ENVIO'
        },
        exibirMensagemAguardeReenvioDocumento(){
            return this.documento.situacao === 'AGUARDANDO_REENVIO'
        },
        exibirRodape(){
            return this.documento.url && this.documento.situacao && this.situacaoFornecedor !== 'DESCLASSIFICADO'
        },
        solicitarReenvio(documento, motivoReenvio) {
            let documentoSolicitado = {
                documentoSolicitadoId: documento.documentoSolicitadoId,
                documentoApresentadoId: documento.id,
                novaSituacao: 'AGUARDANDO_REENVIO',
                motivoReenvio: motivoReenvio
            }
            this.$emit('solicitarReenvio', documentoSolicitado)
        },
        solicitarEnvioDocumento(documento, mensagem) {
            let dados = {
                documentoSolicitadoId: documento.documentoSolicitadoId,
                documentoApresentadoId: documento.id,
                mensagem: mensagem
            }
            this.$emit('solicitarEnvioDocumento', dados)
        },
        solicitarAssinatura(documento){
            const tipos = ['REAJUSTE_PROPOSTA', 'PROTOCOLO', 'TERMO_ACEITE']
            if(tipos.includes(documento.tipoDocumento)){
                const {origemId, ...dadosDocumento} = documento
                this.emitirEventoSolicitarAssinatura({id: origemId, ...dadosDocumento})
            }
            else
                this.emitirEventoSolicitarAssinatura({tipoDocumento: 'DOCUMENTO_APRESENTADO', ...documento})
        },
        emitirEventoSolicitarAssinatura(documento) {
            this.$emit('solicitarAssinatura', {
                documentoId: documento.id,
                tipoDocumento: documento.tipoDocumento,
                descricao: documento.descricao,
                idVirtualizado: documento.idVirtualizado,
                signatarios: documento.signatarios
            })
        },
        exibirPipe() {
            return this.algumaOpcaoEnvioReenvioAtiva() && this.algumaOpcaoAssinaturaEJuntadoAtiva()
        },
        algumaOpcaoEnvioReenvioAtiva() {
            if(this.exibirRodape() && this.opcoesEnvioReenvioAtivas()){
                if(this.botaoSolicitarReenvioAtivo()
                    || this.exibirMensagemAguardeReajuste()
                    || this.exibirMensagemAguardeEnvioDocumento()
                    || this.exibirMensagemAguardeReenvioDocumento()){
                    return true
                }
            }
            return false
        },
        algumaOpcaoAssinaturaEJuntadoAtiva() {
            if (this.ehVirtualizacaoAtiva() && this.documento.idVirtualizado)
                return (['ANALISADO', 'FINALIZADO', 'ATIVO'].includes(this.documento.situacao))

            return false
        },
        handleResize() {
            this.tamanhoJanela = {
                x: window.innerWidth,
                y: window.innerHeight - 159
            }
        },
        ehVirtualizacaoAtiva() {
            return this.virtualizacao
        },
        exibirBotaoAssinatura(documento) {
            if ((documento.tipoDocumento === 'REAJUSTE_PROPOSTA' && this.situacaoCompraEnum !== 'ENCERRADA'))
                return false

            if (this.ehVirtualizacaoAtiva() && this.documento.idVirtualizado)
                return !documento.solicitadoAssinatura || (documento.solicitadoAssinatura && documento.signatarios && documento.signatarios.some(s => s.situacao === 'EXPIRADO'))

            return false
        },
        exibirMensagemAssinaturaSolicitada(documento) {
            return (documento.solicitadoAssinatura && !documento.assinado && !(documento.signatarios && documento.signatarios.some(s => s.situacao === 'EXPIRADO')))
        },
        calcularStatusAssinatura(documento) {
            if (documento && documento.signatarios && documento.signatarios.some(s => s.situacao === 'EXPIRADO')) {
                return 'EXPIRADO'
            }
            if (documento.solicitadoAssinatura && !documento.assinado) {
                return 'ENVIADO'
            }
            return 'NAO_ENVIADA'
        }
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    }
}
</script>

<style scoped lang="stylus">
    .analise-visualizador
        width 80%
        background-color #f8f9fa

        &__titulo
            padding 10px
            text-align center
            color #777
            font-size 16px
            border-bottom 1px solid #e9e9e9
            text-transform uppercase
            background-color #fff

        &__rodape
            position fixed
            bottom 0
            width 80%
            height 50px
            text-align center
            background-color #fff
            border-top 1px solid #eaeaea
            display flex
            align-items center
            justify-content center

            .sample:not(:last-child) {
                content: ' | ';
            }

            &-botao
                color #777
                padding 6px 20px

            &-botao:hover, &-botao:active, &-botao:focus
                background-color #f9f9f9

            &-mensagem
                margin-bottom 0
                color #7f7f7f
                font-size 13px

            &-botao-assinatura {
                color #777
                padding 6px 20px
            }

            &-botao-assinado {
                color var(--v-primary-base)
                padding 6px 20px
                background-color #d4edd9
            }

            &-botao-assinatura:hover, &-botao-assinatura:active, &-botao-assinatura:focus {
                background-color #f9f9f9
            }

        .div-mensagem-botao-documento-nao-enviado
            display flex
            text-align center
            align-items center
            justify-content center
            height calc(100vh - 200px)

    @media (max-width 720px)
        .analise-visualizador
            &, &__rodape
                width 100%

            &__titulo
                padding-left 60px
                font-size 13px
</style>
